<template>
  <b-modal
    id="modal-add-sim-tingbox"
    v-model="isVisible"
    :no-close-on-backdrop="true"
    centered
    @cancel="closeModal"
    @hidden="resetForm"
    size="lg"
  >
    <template #modal-header="{ close }">
      <h4>{{ title }}</h4>
      <button
        type="button"
        class="close"
        data-dismiss="modal"
        @click="
          close()
          closeModal()
        "
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    <div style="display: flex; gap: 10px; padding: 10px">
      <div class="form-group" style="width: 100%">
        <label for="categoryId">Thiết bị tingbox</label>
        <SearchStaffAutocomplete
          v-model="form.categoryId"
          :list="tingboxTypeOptions"
          placeholder="Loại thiết bị"
          size="md"
          @input="loadTingboxDevices"
        />
      </div>
      <div class="form-group" style="width: 100%">
        <label for="serialTingBox">Serial TingBox</label>
        <SearchStaffAutocomplete
          size="md"
          id="serialTingBox"
          v-model="form.serialTingBox"
          :class="{ 'is-invalid': errors.serialTingBox }"
          :placeholder="loadingTingBox ? 'Loading...' : 'Tìm kiếm/Chọn thiết bị'"
          :list="tingboxDeviceOptions"
          :disabled="loadingTingBox"
        />
        <div class="invalid-feedback" v-if="errors.serialTingBox">
          {{ errors.serialTingBox }}
        </div>
      </div>
    </div>

    <div style="display: flex; gap: 10px; padding: 10px">
      <div class="form-group" style="width: 100%">
        <label for="categoryIdSim">Thiết bị sim đi kèm</label>
        <SearchStaffAutocomplete
          size="md"
          v-model="form.categoryIdSim"
          :list="simTypeOptions"
          placeholder="Loại thiết bị sim"
          @input="loadSimDevices"
        />
      </div>
      <div class="form-group" style="width: 100%">
        <label for="serialSim">Serial Sim</label>
        <SearchStaffAutocomplete
          size="md"
          id="serialSim"
          :list="simDeviceOptions"
          v-model="form.serialSim"
          :class="{ 'is-invalid': errors.serialSim }"
          :placeholder="loadingSim ? 'Loading...' : 'Tìm kiếm/Chọn sim'"
          :disabled="loadingSim"
        />
        <div class="invalid-feedback" v-if="errors.serialSim">
          {{ errors.serialSim }}
        </div>
      </div>
    </div>

    <template #modal-footer>
      <div class="w-100" style="display: flex; justify-content: space-between">
        <b-checkbox v-model="form.collectMoney">
          <p style="font-weight: 600; font-family: 'Roboto', sans-serif; font-size: 16px">
            Sim thu tiền riêng (user cần cập nhật phiếu thu sim)
          </p>
        </b-checkbox>
        <div>
          <button class="btn btn-secondary" @click="closeModal">Hủy</button>
          <button class="btn btn-primary ml-2" @click="submitForm" :disabled="isSubmitting">
            <b-spinner small v-if="isSubmitting"></b-spinner>
            Xác nhận
          </button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
  import SearchStaffAutocomplete from '@/components/cskh/SearchStaffAutocomplete.vue'
  import { DeviceService } from '@/services/device.service'

  export default {
    name: 'AddSimTingboxModal',
    components: {
      SearchStaffAutocomplete,
    },
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        default: 'Thêm mới sim kèm Tingbox',
      },
      inventoryOptions: {
        type: Array,
        default: () => [],
      },
      tingboxTypeOptions: {
        type: Array,
        default: () => [],
      },
      simTypeOptions: {
        type: Array,
        default: () => [],
      },
      getTingboxDevices: {
        type: Function,
        default: () => () => [],
      },
      getSimDevices: {
        type: Function,
        default: () => () => [],
      },
    },
    data() {
      return {
        isVisible: false,
        isSubmitting: false,
        loadingTingBox: false,
        loadingSim: false,
        form: {
          inventories: '',
          categoryId: '',
          categoryIdSim: '',
          serialTingBox: '',
          serialSim: '',
          collectMoney: true,
        },
        errors: {
          serialTingBox: '',
          serialSim: '',
        },
        tingboxDeviceOptions: [],
        simDeviceOptions: [],
      }
    },
    watch: {
      visible(newValue) {
        this.isVisible = newValue
      },
      isVisible(newValue) {
        this.$emit('update:visible', newValue)
      },
    },
    methods: {
      closeModal() {
        this.isVisible = false
        this.$emit('close')
      },

      resetForm() {
        this.form = {
          inventories: '',
          categoryId: '',
          categoryIdSim: '',
          serialTingBox: '',
          serialSim: '',
          collectMoney: true,
        }
        this.errors = {
          serialTingBox: '',
          serialSim: '',
        }
        this.tingboxDeviceOptions = []
        this.simDeviceOptions = []
      },

      handleInventoryChange() {
        this.form.collectMoney = true
        this.form.categoryId = ''
        this.form.categoryIdSim = ''
        this.form.serialTingBox = ''
        this.form.serialSim = ''
        this.tingboxDeviceOptions = []
        this.simDeviceOptions = []
      },

      async loadTingboxDevices() {
        try {
          this.loadingTingBox = true

          // Use the function passed from parent component
          if (this.form.categoryId && this.getTingboxDevices) {
            this.tingboxDeviceOptions = this.getTingboxDevices(this.form.categoryId)
          } else {
            this.tingboxDeviceOptions = []
          }
        } catch (error) {
          console.error('Error loading tingbox device list:', error)
          this.$emit('error', 'Không thể tải danh sách thiết bị TingBox')
        } finally {
          this.loadingTingBox = false
        }
      },

      async loadSimDevices() {
        try {
          this.loadingSim = true

          // Use the function passed from parent component
          if (this.form.categoryIdSim && this.getSimDevices) {
            this.simDeviceOptions = this.getSimDevices(this.form.categoryIdSim)
          } else {
            this.simDeviceOptions = []
          }
        } catch (error) {
          console.error('Error loading sim device list:', error)
          this.$emit('error', 'Không thể tải danh sách thiết bị SIM')
        } finally {
          this.loadingSim = false
        }
      },

      validateForm() {
        this.errors = {
          serialTingBox: '',
          serialSim: '',
        }

        let isValid = true

        if (!this.form.serialTingBox) {
          this.errors.serialTingBox = 'Vui lòng nhập Serial TingBox'
          isValid = false
        }

        if (!this.form.serialSim) {
          this.errors.serialSim = 'Vui lòng nhập Serial Sim'
          isValid = false
        }

        return isValid
      },

      async submitForm() {
        if (!this.validateForm()) {
          return
        }

        try {
          this.isSubmitting = true

          const response = await DeviceService.addTingboxsim({
            serialTingBox: this.form.serialTingBox,
            serialSim: this.form.serialSim,
            collectMoney: this.form.collectMoney,
          })

          if (response.code === 1000) {
            this.$emit('success', 'Thêm mới thiết bị thành công')
            this.closeModal()
          } else {
            this.$emit('error', response.data || response.message || 'Thêm mới không thành công')
          }
        } catch (error) {
          console.error('Error adding new device:', error)
          this.$emit('error', `Đã xảy ra lỗi: ${error.message || 'Không thể kết nối đến máy chủ'}`)
        } finally {
          this.isSubmitting = false
        }
      },
    },
  }
</script>

<style scoped>
  .form-group {
    margin-bottom: 1rem;
  }

  .is-invalid {
    border-color: #dc3545;
  }

  .invalid-feedback {
    display: block;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 0.875em;
    color: #dc3545;
  }
</style>
